import { FC, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useLocation as useLocationData } from '../../../../api/apiQueries'
import { READ_JURISDICTION_RULES_SCOPE, READ_PERMITS_SCOPE, READ_PERMITTING_COMMENTS_SCOPE } from '../../../../constants'
import { getPermitBannerErrorMessage } from '../../../../utils/permitUtils'
import { Box } from '@mui/material'
import { Banner } from '../../../../components/Banner/Banner'
import { PermitsTable } from './PermitsTable'
import { AuthCheck } from '../../../../components/AuthCheck'
import { Notes } from './Notes'

export const PermitsTab: FC = () => {
  const { sid: locationId } = useParams()
  const locationQuery = useLocationData(locationId)

  const locationData = locationQuery.data
  const bannerDetails = useMemo(() => (locationData ? getPermitBannerErrorMessage(locationData) : null), [locationData])

  return (
    locationData && (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-l)' }}>
        <AuthCheck has={READ_JURISDICTION_RULES_SCOPE}>
          {bannerDetails && <Banner type={bannerDetails.type} title={bannerDetails.title} body={bannerDetails.body} />}
        </AuthCheck>
        <AuthCheck has={READ_PERMITS_SCOPE}>
          <PermitsTable location={locationData} />
        </AuthCheck>
        <AuthCheck has={READ_PERMITTING_COMMENTS_SCOPE}>
          <Notes location={locationData} />
        </AuthCheck>
      </Box>
    )
  )
}
